import type { SignedAgreementResponse, Territory, Vendor } from "Src/api/Dto";

import { getSignedAgreements, getTerritories, getVendors, getVendorsWithSignedAgreement } from "Src/api/Publishers";

import { getSessionStorage } from "Src/utils/Utils";

import { actionApp, pendingApp } from "./StoreApp";

export const loadAll = actionApp(async (_store, brId: string) => {
  pendingApp("allVendors", true);
  let v = getSessionStorage<Vendor[]>("allVendors");
  let t = getSessionStorage<Territory[]>("territories");
  const promiseArr: Promise<Territory[] | Vendor[] | SignedAgreementResponse[]>[] = [
    getVendorsWithSignedAgreement(brId),
    getSignedAgreements(brId)
  ];
  if (!v) {
    promiseArr.push(getVendors(brId));
  }
  if (!t) {
    promiseArr.push(getTerritories(brId));
  }

  const [signedVendors, signedAgreements, vendors, territories] = (await Promise.all(promiseArr)) as [Vendor[], SignedAgreementResponse[], Vendor[], Territory[]];

  if (!v) {
    v = vendors;
    sessionStorage.setItem("allVendors", JSON.stringify(vendors));
  }
  if (!t) {
    t = territories;
    sessionStorage.setItem("territories", JSON.stringify(territories));
  }

  pendingApp("allVendors", false);

  return {
    signedVendors,
    signedAgreements,
    allVendors: v,
    territories: t
  };
});

export const loadSignedVendors = actionApp(async (_, brId: string) => {
  const [signedVendors, signedAgreements] = await Promise.all([
    getVendorsWithSignedAgreement(brId),
    getSignedAgreements(brId)
  ]);

  return {
    signedVendors,
    signedAgreements
  };
});
